import React, { Component } from 'react';

export default class Automated extends Component {
	render() {
		return (
			<svg
				style={this.props.style}
				version='1.1'
				id='Capa_1'
				xmlns='http://www.w3.org/2000/svg'
				xmlnsXlink='http://www.w3.org/1999/xlink'
				x='512px'
				y='512px'
				viewBox='0 0 330 330'
				xmlSpace='preserve'
			>
				<g>
					<path
						fill={this.props.fill}
						d='M315,120h-22.689c-1.587-4.488-3.415-8.893-5.476-13.196l16.05-16.051c5.858-5.857,5.858-15.355,0-21.213L260.46,27.114
		c-5.857-5.858-15.355-5.858-21.213,0l-16.051,16.05c-4.303-2.06-8.707-3.887-13.196-5.476V15c0-8.284-6.716-15-15-15h-60
		c-8.284,0-15,6.716-15,15v22.689c-4.488,1.588-8.893,3.415-13.195,5.475l-16.051-16.05c-5.857-5.859-15.355-5.858-21.213,0
		L27.114,69.54c-2.813,2.813-4.394,6.628-4.394,10.606s1.58,7.794,4.394,10.606l16.051,16.051c-2.06,4.304-3.888,8.708-5.476,13.196
		H15c-8.284,0-15,6.716-15,15v60c0,8.284,6.716,15,15,15h22.689c1.588,4.488,3.416,8.893,5.476,13.196l-16.051,16.051
		c-2.813,2.813-4.394,6.628-4.394,10.606s1.58,7.794,4.394,10.606l42.428,42.426c5.858,5.859,15.355,5.857,21.213,0l16.051-16.05
		c4.302,2.06,8.706,3.887,13.194,5.475V315c0,8.284,6.716,15,15,15h60c8.284,0,15-6.716,15-15v-22.689
		c4.489-1.589,8.894-3.416,13.196-5.476l16.051,16.05c5.857,5.857,15.355,5.857,21.213,0l42.426-42.426
		c5.858-5.857,5.858-15.355,0-21.213l-16.05-16.051c2.061-4.304,3.889-8.708,5.476-13.196H315c8.284,0,15-6.716,15-15v-60
		C330,126.716,323.284,120,315,120z M300,180h-18.781c-6.845,0-12.822,4.634-14.527,11.263c-2.436,9.472-6.213,18.576-11.227,27.06
		c-3.482,5.894-2.533,13.396,2.308,18.237l13.294,13.294l-21.213,21.213l-13.294-13.294c-4.84-4.84-12.342-5.788-18.237-2.308
		c-8.479,5.011-17.584,8.788-27.062,11.228c-6.628,1.706-11.261,7.683-11.261,14.526V300h-30v-18.781
		c0-6.844-4.633-12.82-11.261-14.526c-9.476-2.44-18.579-6.217-27.06-11.228c-5.895-3.482-13.396-2.533-18.237,2.308l-13.294,13.294
		l-21.215-21.213l13.294-13.294c4.841-4.84,5.79-12.343,2.308-18.236c-5.011-8.481-8.789-17.587-11.228-27.063
		C61.602,184.633,55.625,180,48.781,180H30v-30h18.781c6.844,0,12.82-4.633,14.526-11.261c2.439-9.476,6.217-18.581,11.228-27.063
		c3.482-5.894,2.533-13.397-2.308-18.236L58.934,80.146l21.214-21.213l13.294,13.294c4.84,4.84,12.345,5.79,18.237,2.308
		c8.479-5.011,17.584-8.788,27.061-11.228C145.367,61.602,150,55.625,150,48.781V30h30v18.781c0,6.844,4.633,12.82,11.261,14.526
		c9.478,2.44,18.583,6.217,27.062,11.228c5.893,3.48,13.396,2.533,18.237-2.308l13.294-13.294l21.213,21.213L257.772,93.44
		c-4.841,4.841-5.79,12.344-2.308,18.237c5.014,8.483,8.79,17.588,11.227,27.06c1.705,6.629,7.683,11.263,14.527,11.263H300V180z'
					/>
					<path
						fill={this.props.fill}
						d='M203.95,152.28l-48-30c-4.624-2.891-10.453-3.043-15.222-0.4c-4.77,2.644-7.729,7.667-7.729,13.12v60
		c0,5.453,2.959,10.477,7.729,13.12c2.266,1.255,4.77,1.88,7.271,1.88c2.764,0,5.523-0.763,7.95-2.28l48-30
		c4.386-2.741,7.05-7.548,7.05-12.72S208.336,155.021,203.95,152.28z'
					/>
				</g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
				<g></g>
			</svg>
		);
	}
}
